const config = {
  CMEfilter: false,
  mainColor: "#cb2327",
  primaryContrastText: "#fff",
  secondaryColor: "#0772af",
  secondaryContrastText: "#fff",
  searchPlaceholder: "What do you want to learn?",
  loginText: "",
  requireAuth: false,
  showOnDemand: true,
  showBuy: false,
  showSignUp: false,
  showSponsors: true,
  showSponsorsPage: false,
  sponsorsPageCards: true,
  sponsorsCardsHorizontal: false,
  showEvents: false,
  eventsDebugMode: false,
  showProducts: false,
  showSchedule: true,
  trackPageScrollOffset: -80,
  showExhibitHall: true,
  showChat: true,
  enablePlaybackTracking: false,
  showPrivacyPolicy: false,
  // externalPrivacyPolicyUrl: "//www.ya.ru",
  acceptPrivacyPolicyText: "",
  emailHelperText: "",
  showSessionEvaluation: false,
  showRecordingEvaluation: false,
  showAskSpeaker: false,
  supportEmail: "info@slidespiel.com",
  portals: [
    { 
      year: 2020,
      logo: 'logo.jpg',
      signInRedirect: "/on-demand",
      trackImages: false,
      home: {
        minHeight: 500,
        height: '70vh',
        paperMarginType: 'Right',
        paperMargin: '0vw',
        paperMaxWidth: 800,
        paperColor: 'rgba(0,0,0,.0)',
        backgroundUrl: 'background.jpg',
        backgroundPosition: { x: 50, y: 40 },
        backgroundRatio: 0.25,
        justifyContent: 'center',
        alignItems: 'center',
        color: "#fff",
        buttonColor: "primary",
        getLink: "/on-demand",
        showHero: true,
        showCta: true,
        showCtaText: false,
        ctaPadding: [2, 4],
        //fontFamily: "Fira Sans",
        //fontWeight: 'bold',
      },
    },
  ],
  main: {
    logoMarginTop: 5,
    logoPadding: 0,
    logoHeight: 70,
    logoHeightXs: 50,
    progressBarTop: 79,
    progressBarTopXs: 55,
    childrenMarginTop: 79,
    childrenMarginTopXs: 50,
    searchColor: "primary",
    barColor: "default",
    barTextColor: "primary",
    barButtonColor: "primary"
  },
  footer: {
    // facebookUrl: "https://www.facebook.com/",
    // twitterUrl: "https://twitter.com/",
    // instagramUrl: "https://instagram.com/",
    // linkedInUrl: "https://www.linkedin.com/",
  },
  eventHome: {
    titleColor: "primary",
    subtitleColor: "secondary",
    liveColor: "primary",
    registerColor: "primary",
    exhibitHallColor: "secondary",
    networkingRoomColor: "primary",
  }
};

export default config;
